import type { FileType } from '@/types/dtos/media/media.asset.dto.ts';

const GIB = 1024 ** 3;
const MIB = 1024 ** 2;

export const MEDIA_UPLOAD_MAX_BYTES_BY_FILE_TYPE: Readonly<Record<FileType, number>> = {
  presentation: 2 * GIB,
  pdf: 2 * GIB,
  video: 5 * GIB,
  audio: 500 * MIB,
  image: 10 * MIB,
  imageSequence: 10 * MIB,
};

export const MEDIA_UPLOAD_FILE_TYPE_LABELS: Readonly<Record<FileType, string>> = {
  presentation: 'Presentation',
  pdf: 'PDF',
  video: 'Video',
  audio: 'Audio',
  image: 'Image',
  imageSequence: 'Image',
};
